import {
    EXCHANGE_CODE,
    EXCHANGE_CODE_SUCCESS,
    EXCHANGE_CODE_FAILED
  } from "./actionTypes"
  
  export const exhangeCode = (type,code) => {
    return {
      type: EXCHANGE_CODE,
      payload: {type,code}
    }
  }
  
  export const exhangeCodeSuccess = data => {
    return {
      type: EXCHANGE_CODE_SUCCESS,
      payload: {data},
    }
  }
  
  export const exhangeCodeFailed = errorDetails => {
    return {
      type: EXCHANGE_CODE_FAILED,
      payload: {errorDetails}
    }
  }
  
  